import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import {
  EXPORT
} from '@hobs/constants/reports';

export function exportReports() {
    return dispatch => {
      dispatch(request());
      return fetchSecure('reports/supplier', { forceBlob: true })
        .then(response => {
          if (response) {
            dispatch(success());
            return { success: true, blob: response };
          } else {
            dispatch(failure(response.toString()));
            return { success: false, ...response };
          }
        })
        .catch(error => {
          dispatch(failure(error.toString()));
        });
    };

    function request() {
      return { type: EXPORT.REQUEST };
    }
    function success() {
      return { type: EXPORT.SUCCESS };
    }
    function failure(error) {
      return { type: EXPORT.FAILURE, error };
    }
}

export function exportLeftoverReports(includeItemsWithoutWarehouseInformation, includeItemsWithoutServiceRequests) {
    return dispatch => {
      dispatch(request());
      return fetchSecure('reports/leftovers', {
          params: {
            includeItemsWithoutWarehouseInformation,
            includeItemsWithoutServiceRequests
          },
          forceBlob: true
        })
        .then(response => {
          if (response) {
            dispatch(success());
            return { success: true, blob: response };
          } else {
            dispatch(failure(response.toString()));
            return { success: false, ...response };
          }
        })
        .catch(error => {
          dispatch(failure(error.toString()));
        });
    };

    function request() {
      return { type: EXPORT.REQUEST };
    }
    function success() {
      return { type: EXPORT.SUCCESS };
    }
    function failure(error) {
      return { type: EXPORT.FAILURE, error };
    }
}

export function exportSupplierAmountVsSnAmountsReports() {
    return dispatch => {
      dispatch(request());
      return fetchSecure('reports/Supplier-amount-vs-sn-amounts', { forceBlob: true })
        .then(response => {
          if (response) {
            dispatch(success());
            return { success: true, blob: response };
          } else {
            dispatch(failure(response.toString()));
            return { success: false, ...response };
          }
        })
        .catch(error => {
          dispatch(failure(error.toString()));
        });
    };

    function request() {
      return { type: EXPORT.REQUEST };
    }
    function success() {
      return { type: EXPORT.SUCCESS };
    }
    function failure(error) {
      return { type: EXPORT.FAILURE, error };
    }
}